import { get, ref } from 'firebase/database';
import { Person } from '../../Models/person';
import { database } from '../firebase';

export const getPerson: (id: string) => Promise<Person | null> = async (id) => {
    let returnPerson: Person | null = null;

    await get(ref(database, `people/${id}`))
        .then((snapshot) => {
            if (snapshot.exists()) {
                returnPerson = snapshot.val();
            }
        })
        .catch((err) => {
            throw err;
        });

    return returnPerson;
};
